module.exports = __webpack_public_path__ + "static/media/model.fdc47886.svg";